import { render, staticRenderFns } from "./SetIndexation.vue?vue&type=template&id=1597bac0&"
import script from "./SetIndexation.vue?vue&type=script&lang=js&"
export * from "./SetIndexation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports